import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

@inject(['websites'])
@observer
class WebsiteChooser extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  handleClick = id => {
    this.props.websites.setCurrent(id)
    this.context.router.push(id ? `/website/${id}` : '/')
  }

  render() {
    const { websites } = this.props

    if (!websites.loaded) return <div className="loading">Loading Websites...</div>

    return (
      <div>
        {Object.values(websites.websites).map(website => (
          <div className="website" key={website.id} onClick={this.handleClick.bind(null, website.id)}>{website.name}</div>
        ))}
      </div>
    )
  }
}

export default WebsiteChooser



// WEBPACK FOOTER //
// client/components/navigation/WebsiteChooser.js